import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import copy from 'clipboard-copy';
import toast from 'react-hot-toast';

import logo from '../imagenes/logo1_bccy_blanco.svg';

const LINKEDIN = 'https://www.linkedin.com/company/bccy-colombia/jobs/?viewAsMember=true';
const YOUTUBE = 'https://www.youtube.com/channel/UCTBxxvzMkx8iEwuDEitBP8g';

const telefonos = [
  { ciudad: 'Bogotá', numero: '601-7569677' },
  { ciudad: 'Medellín', numero: '3242422661' },
  { ciudad: 'Chinu - Córdoba', numero: '3002521788' },
];

const EMAIL_RRHH = 'c.palacio@bccynewpower.com';
const TEL_RRHH = '3242422692';

function FooterCordoba() {
  const copiar = (texto) => {
    copy(texto);
    toast.success(texto + ' copiado al portapapeles');
  };

  return (
    <footer className="footer-container">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-col">
            <h2>BCCY Córdoba</h2>
            <p className="footer-brand-desc">
              Desarrollo y operación de proyectos en la región de Córdoba Con un fuerte compromiso regional.
            </p>
          </div>

          <div className="footer-col">
            <h2>Contacto Chinu</h2>
            <ul className="footer-list">
              {telefonos.map((t) => (
                <li key={t.numero}>
                  <button type="button" className="footer-link" onClick={() => copiar(t.numero)}>
                    <span>
                      <span className="footer-city">{t.ciudad}</span>
                      {t.numero}
                    </span>
                    <i className="fas fa-copy" />
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h2>Trabaje con Nosotros</h2>
            <ul className="footer-list">
              <li>
                <a className="footer-link" href={'mailto:' + EMAIL_RRHH}>
                  {EMAIL_RRHH}
                  <i className="fas fa-envelope" />
                </a>
              </li>
              <li>
                <button type="button" className="footer-link" onClick={() => copiar(TEL_RRHH)}>
                  {TEL_RRHH}
                  <i className="fas fa-copy" />
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h2>Enlaces</h2>
            <ul className="footer-list">
              <li>
                <Link className="footer-link" to="/">
                  Inicio
                </Link>
              </li>
              <li>
                <Link className="footer-link" to="/contactc">
                  Contáctenos
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <Link to="/" className="footer-logo">
            <img src={logo} alt="BCCY" className="footer-logo-image" />
          </Link>

          <small className="footer-rights">BCCY 2026</small>

          <div className="footer-social">
            <a className="footer-social-link" href={YOUTUBE} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube" />
            </a>
            <a className="footer-social-link" href={LINKEDIN} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterCordoba;
